export type SaleConfig = {
  /**
   * Manual switch. When false, sale pages can still exist, but UI can choose
   * to hide links/banners/etc.
   */
  saleActive: boolean
  saleName: string
  saleUrl: string
  /**
   * Informational only for now (manual-only active). ISO timestamp strings.
   * Example: "2025-11-28T00:00:00Z"
   */
  saleStartDate?: string
  saleEndDate?: string
  saleHeroImageUrl: string
  saleHeroImageAlt: string
  salePopupImageUrl: string
  saleSectionImages: {
    all: string
    magicTricks: string
    magicBooks: string
    ebooks: string
    downloads: string
  }
  salePopupTriggerDelayMs: number
  salePopupStorageExpireDays: number
  saleShortcutLinks: {
    label: string
    href: string
  }[]
  /**
   * Optional override for the default sale meta description.
   * If omitted, we’ll generate one from `saleName`.
   */
  defaultMetaDescription?: string
}

const SUMMER_SALE_URL = '/sale/all/'
const SUMMER_SALE_CAROUSEL_IMAGE =
  'https://vinc.gumlet.io/gallery/carousel/summer-sale.jpg'
const SUMMER_SALE_SECTION_IMAGE_BASE =
  'https://vinc.gumlet.io/pics/specials/bf2025-back'

/**
 * Global sale configuration.
 */
export const SALE_CONFIG: SaleConfig = {
  saleActive: false,
  saleName: 'Summer Sale 2026',
  saleUrl: SUMMER_SALE_URL,
  saleStartDate: undefined,
  saleEndDate: undefined,
  saleHeroImageUrl: SUMMER_SALE_CAROUSEL_IMAGE,
  saleHeroImageAlt: 'Summer Sale 2026',
  salePopupImageUrl:
    'https://vinc.gumlet.io/gallery/popups/summer-sale.jpg?w=1280&format=webp',
  saleSectionImages: {
    all: `${SUMMER_SALE_SECTION_IMAGE_BASE}/all-discounts.jpg?w=240&dpr=1.3`,
    magicTricks: `${SUMMER_SALE_SECTION_IMAGE_BASE}/discounted-tricks.jpg?w=240&dpr=1.3`,
    magicBooks: `${SUMMER_SALE_SECTION_IMAGE_BASE}/discounted-books.jpg?w=240&dpr=1.3`,
    ebooks: `${SUMMER_SALE_SECTION_IMAGE_BASE}/discounted-ebooks.jpg?w=240&dpr=1.3`,
    downloads: `${SUMMER_SALE_SECTION_IMAGE_BASE}/discounted-downloads.jpg?w=240&dpr=1.3`,
  },
  salePopupTriggerDelayMs: 5000,
  salePopupStorageExpireDays: 1,
  saleShortcutLinks: [
    {
      label: 'Biggest discounts',
      href: '/sale/all/in-stock/biggest-discount/1/',
    },
    {
      label: 'Best-selling deals',
      href: '/sale/all/in-stock/best-sellers/1/',
    },
    {
      label: 'Instant downloads',
      href: '/sale/downloads/',
    },
    {
      label: 'VI exclusives',
      href: '/sale/all/exclusives/best-sellers/1/',
    },
  ],
  defaultMetaDescription:
    'Shop the Summer Sale 2026 at Vanishing Inc. Magic for discounted tricks, books, ebooks, and downloads.',
}
